import { defineMessages } from 'react-intl';

const messages = defineMessages({
  smartfillAltText: {
    defaultMessage: 'SmartFill Applied',
    id: 'aS46tD',
    description: 'text to display as alternate text for',
  },
  tooltipMessage: {
    description: 'tooltip message to display',
    defaultMessage: 'SmartFill applied based on {count} previous shipments',
    id: 'qRG1dJ',
  },
});

export default messages;
